import * as React from 'react';
import {  NavLink } from "react-router-dom";
import logo from "../assets/logos/Logo_White_LogoNoName.png"
import {
  Stack,
  AppBar,
  Box,
  Typography,
  Toolbar,
  Container,
  Drawer,
  List,
  ListItem,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import ClearIcon from '@mui/icons-material/Clear';
import IconButton from '@mui/material/IconButton';
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const pages = {
  "Home" : "/",
  "Our Story" : "/our-story",
  "RSVP" : "/rsvp",
  "Details" : "/details",
  "Entourage" : "/entourage",
  "Stay" : "/stay",
  "FAQ" : "/faq"
};

export default function Nav() {

  const [state, setState] = React.useState({
    menu: false,
  });

  const toggleDrawer = (menu, open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setState({ ...state, [menu]: open });
  };

  return (
    <>
    <AppBar position="static">
      <Box
        component="div"
        sx={{ display: { xs: 'flex', lg: 'none' } }}
      >
        <Container maxSize="xl">
          <Toolbar disableGutters>
            <Box 
              component="div"
              sx={{ flexGrow: 1, display: { xs: 'flex', lg: 'none' }  }}
              justifyContent="flex-start"
            >
              <Link to="/">
                <img src={logo} alt="JP & Nadine home" title="Home" width={70}/>
              </Link>
            </Box>
            <Box 
              component="div"
              sx={{ flexGrow: 0, display: { xs: 'flex', lg: 'none' }  }}
            >
              <React.Fragment key="menu">
                <IconButton
                  size="large"
                  aria-label="menu bar"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={toggleDrawer("menu", true)}
                  color="inherit"
                >
                  <MenuIcon className="menu-icon"/>
                </IconButton>
                <Drawer
                  anchor="right"
                  open={state["menu"]}
                  onClose={toggleDrawer("menu", false)}
                >
                  <Box
                      sx={{ width: 300, height: "100vh" }}
                      role="presentation"
                      onClick={toggleDrawer("menu", false)}
                      onKeyDown={toggleDrawer("menu", false)}
                      className="mobile-nav"
                    >
                      <Box
                        display="flex"
                        className="mobile-nav-close"
                        justifyContent="flex-end"
                      >
                        <IconButton
                          onClick={toggleDrawer("menu", false)}
                          size="large"
                          sx={{mr:'24px', mt:'24px'}}
                        >
                          <ClearIcon></ClearIcon>
                        </IconButton>
                      </Box>
                      <List>
                        {Object.keys(pages).map((text) => (
                          <NavLink
                            to={pages[text]}
                            className={({ isActive }) => 
                              (isActive ? "mobile-nav-link mobile-nav-link-active" : "mobile-nav-link")}
                          >
                            <ListItem button key={text}>
                              <Typography
                              variant="body2"
                              textAlign="center"
                              >{text}</Typography>
                            </ListItem>
                          </NavLink>
                        ))}
                      </List>
                    </Box>
                </Drawer>
              </React.Fragment>
            </Box>
          </Toolbar>
        </Container>
      </Box>
      <Stack 
        direction="row" 
        sx={{ flexGrow: 0, display: { xs: 'none', lg: 'flex' } }}
        spacing={7}
        justifyContent="center"
        alignItems="center"
        className="nav-bar"
      >
        <NavLink to="/our-story" className="nav-link">
          <motion.div whileHover={{ scale: 1.02 }}>Our Story</motion.div>
        </NavLink>
        <NavLink to="/rsvp" className="nav-link">
          <motion.div whileHover={{ scale: 1.02 }}>RSVP</motion.div>
        </NavLink>
        <NavLink to="/details" className="nav-link">
          <motion.div whileHover={{ scale: 1.02 }}>Details</motion.div>
        </NavLink>
        <NavLink to="/">
          <img src={logo} alt="JP & Nadine home" title="Home" width={70}/>
        </NavLink>
        <NavLink to="/entourage" className="nav-link">
          <motion.div whileHover={{ scale: 1.02 }}>Entourage</motion.div>
        </NavLink>
        <NavLink to="/stay" className="nav-link">
          <motion.div whileHover={{ scale: 1.02 }}>Stay</motion.div>
        </NavLink>
        <NavLink to="/faq" className="nav-link">
          <motion.div whileHover={{ scale: 1.02 }}>FAQ</motion.div>
        </NavLink>
      </Stack>
    </AppBar>
    </>
  );
}